// extracted by mini-css-extract-plugin
export default {"root":"SectionGroup__root--l2nH1","sticky":"SectionGroup__sticky--tXjZC"};